import * as React from "react";
import "./index.css";

const TxReceiptTile = ({ image, title, date, cost, index, onClick }) => {
  return (
    <div
      className="tx-receipt-tile"
      onClick={onClick}
      style={{
        backgroundColor: index % 2 === 0 ? "var(--lightGrey)" : "white",
      }}
    >
      <img src={image} alt={title} />
      <div>
        <span>{title}</span>
        <span className="cell">
          <span>Post Date:&nbsp;</span>
          <strong>{date}</strong>
        </span>
        <span className="cell">
          <span>Cost:&nbsp;</span>
          <strong>${cost}</strong>
        </span>
      </div>
    </div>
  );
};

export default TxReceiptTile;
